import type { SpaceOverlayRow } from '@toolproof-core/visualization/runtime/_contract/overlay';


export function buildPrimitiveOperationPlaybackStateRows(args: {
    stepIndex: number | undefined;
    stepCount: number | undefined;
    step: { label: string; description: string } | undefined;
}): SpaceOverlayRow[] {
    if (args.stepIndex === undefined || args.stepCount === undefined || args.step === undefined) return [];
    return [
        {
            key: 'Primitive Step',
            value: `${args.stepIndex} / ${args.stepCount - 1}`,
        },
        { key: 'Primitive Phase', value: args.step.label },
        { key: 'Primitive Description', value: args.step.description },
    ];
}